import { type PropsWithChildren, type ReactNode } from "react";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface ModalContentProps extends PropsWithChildren {
  className?: string;
  description?: ReactNode;
  footer?: ReactNode;
  icon?: ReactNode;
  title: ReactNode;
}

export function ModalContent({
  children,
  className,
  description,
  footer,
  icon,
  title,
}: ModalContentProps) {
  return (
    <DialogContent
      className={cn(
        "max-h-[calc(100dvh-32px)] gap-0 overflow-hidden border-0 p-0 shadow-[0_24px_32px_rgba(13,31,20,0.30)] [display:flex] flex-col sm:rounded-[28px] [&>button]:right-6 [&>button]:top-5 [&>button]:text-[#5b616d] [&>button]:opacity-100 [&>button_svg]:h-5 [&>button_svg]:w-5",
        className,
      )}
    >
      <DialogHeader className="shrink-0 border-b border-[#dddfe4] px-6 py-4 pr-14 text-left">
        <DialogTitle className="flex items-center gap-3 text-xl font-semibold leading-[26px]">
          {icon}
          {title}
        </DialogTitle>
        {description && (
          <DialogDescription className="pt-1 text-sm leading-5 text-[#5b616d]">
            {description}
          </DialogDescription>
        )}
      </DialogHeader>
      <div className="min-h-0 overflow-y-auto overscroll-contain p-6">{children}</div>
      {footer && <div className="shrink-0 border-t border-[#dddfe4] px-6 py-4">{footer}</div>}
    </DialogContent>
  );
}
